module.exports = __webpack_public_path__ + "img/Coat.c6744ea4.svg";